/* eslint-disable @angular-eslint/directive-selector */
import { DestroyRef, Directive, inject, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationMenuService } from '../services/navigation-menu/navigation-menu.service';
import { filter } from 'rxjs';

@Directive({
  selector: '[leftbarTopContent]',
  standalone: true
})
export class LeftbarTopContentDirective implements OnInit {

  private destroyRef = inject(DestroyRef);
  constructor(
    private navigationMenu: NavigationMenuService,
    private viewRef: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.navigationMenu.cta
      .pipe(filter(x => !!x), takeUntilDestroyed(this.destroyRef))
      .subscribe((template: TemplateRef<any>) => {
        this.viewRef.clear();
        this.viewRef.createEmbeddedView(template);
      });
  }
}
